

import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';

var Browser_data = function() {
	this.moz = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	this.chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	this.mobile =  function() {
		var check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};
	this.detect_ie = function(){
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf('MSIE ');
		var trident = ua.indexOf('Trident/');
		var bool;
		if (msie > 0) {
			bool = 'ln10';
		} else if (trident > 0) {
			bool =  true;
		} else {
			bool = false;
		}
		return bool;
	},
	this.fuie = this.detect_ie() === true || this.detect_ie() === 'ln10';
};
window.browser = new Browser_data();
window.fold = 760;

function browser_print(){
	if(browser.fuie){
		document.body.className += " fuie";
	}  if(browser.moz){
		document.body.className += " moz";
	}  if(browser.chrome){
		document.body.className += " chrome";
	}  if (browser.mobile()) {
		document.body.className += " mobile";
	}
};browser_print();

function Lib(){
	this.viewport = function(){
		var e = window, a = 'inner';
		if (!('innerWidth' in window )) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};
	this.each = function(nl,callback){
		var nodes = document.querySelectorAll(nl),
			nodes_array = Array.prototype.slice.call(nodes);
		nodes_array.forEach(function(e){
			if(typeof callback === "function") callback(e);
		});
	};

}
Lib.prototype.wrapper = document.getElementById('wrapper');
Lib.prototype.dir = function(){
	var x;
	if(window.getComputedStyle(this.wrapper,null).getPropertyValue('direction')){
		x = "right";
	} else {
		x = "left";
	}
	return	x;
};
Lib.prototype.isScrolledIntoView = function(elem) {
	var elem_top_pos = elem.getBoundingClientRect().top -100,
		window_height = this.viewport().height,
		elem_bottom_pos = elem.getBoundingClientRect().bottom + 100,
		first_con = elem_top_pos < window_height,
		second_con = elem_bottom_pos > 0;
	return first_con && second_con;
	
};
Lib.prototype.parentsUntil = function(el,parent_name){
    var parent = el.parentNode;
    while(parent.className.indexOf(parent_name) === -1){
        parent = parent.parentNode;
    }
    return parent;
};
Lib.prototype.compute_style = function(el,style,toint){
	if(toint) {
		 return parseInt(window.getComputedStyle(el,null).getPropertyValue(style));
	} else {
		return window.getComputedStyle(el,null).getPropertyValue(style);
	}
};
Lib.prototype.above = function(el,event){
	var cx = browser.mobile() ? event.changedTouches[0].pageX : event.clientX,
		cy = browser.mobile() ? event.changedTouches[0].pageY : event.clientY;
	return !((el.getBoundingClientRect().right < cx) || (el.getBoundingClientRect().left > cx) || 
		(el.getBoundingClientRect().top > cy) || (el.getBoundingClientRect().bottom < cy));

};
Lib.prototype.acc = function(args,bool){
	var el = args.selector;
	var speed = args.speed ? args.speed : 200;
	el.style.height = "auto";
	el.style.overflow = "hidden";
	var height = el.offsetHeight;
	el.style.height = "0px";
	el.style.transition = "height " + speed + "ms";
	el.style.webkitTransition = "height " + speed + "ms";
	if(bool){
		setTimeout(function(){
			el.style.height = height + "px";
			setTimeout(function(){
				el.style.height = "auto";
			},speed);
		},10);
	} else {
		el.style.height = height + "px";
		setTimeout(function(){
			el.style.height = "0px";
		},10);
	}
};
Lib.prototype.preventPageScrolling = function(e){
	e = e || window.event;
	e.preventDefault();
};
Lib.prototype.scrolling_off = function(){
	window.addEventListener('wheel',this.preventPageScrolling);
	window.addEventListener('touchmove',this.preventPageScrolling);
};
Lib.prototype.scrolling_on = function(){
	window.removeEventListener('wheel',this.preventPageScrolling);
	window.removeEventListener('touchmove',this.preventPageScrolling);
};

Lib.prototype.fold = 750;
window.lib = new Lib();



// WEBPACK FOOTER //
// ./assets/js/lib.js